import {Route, Navigate, Outlet} from "react-router-dom";
import {useSelector} from "react-redux";

const ProtectedRoute = ({children}) => {
  const {token, isAuthenticated, loading} = useSelector((state) => state.auth); // Replace 'auth' with the appropriate reducer name in your application

  if (!token && !isAuthenticated && !loading) {
    // If the token is not present, redirect to the login page
    return <Navigate to="/" replace />;
  }

  // If the token is present, allow access to the protected route
  return children;
};

export default ProtectedRoute;
